import React from 'react';

const RenderSensorCard = ({icon, title, value, unit, sensorType, supportedSensors, isAdminUser}) => {
    // Check if it's an admin-only sensor (Battery or SensorTemp)
    const isAdminSensor = sensorType === 'Battery' || sensorType === 'SensorTemp';
    
    // If it's an admin sensor but user is not admin, don't render
    if (isAdminSensor && !isAdminUser) {
        return null;
    }
    
    // For regular sensors, check if they're supported
    if (!isAdminSensor && !supportedSensors.lvl1.includes(sensorType) && !supportedSensors.lvl2.includes(sensorType)) {
        return null;
    }

    if (value === null || value === undefined || value === -1) {
        return null;
    }

    // Special styling for admin sensors
    const getCardStyling = () => {
        if (sensorType === 'Battery') {
            const batteryValue = Array.isArray(value) ? value[0] : value;
            let borderColor = 'border-yellow-500';
            let bgColor = 'bg-yellow-50 bg-opacity-50';
            
            return `${bgColor} ${borderColor} border-2`;
        }
        
        if (sensorType === 'SensorTemp') {
            return 'bg-blue-50 border-blue-500 border-2';
        }
        
        return 'bg-white';
    };

    const getAdminBadge = () => {
        if (isAdminSensor) {
            return (
                <span className="absolute top-2 right-2 bg-indigo-600 text-white text-xs px-2 py-1 rounded-full">
                    Admin
                </span>
            );
        }
        return null;
    };


    const renderValue = () => {
        if (Array.isArray(value)) {
            return (
                <>
                    <h3 className="text-xl font-semibold mb-2">{title}</h3>
                    {supportedSensors.lvl1.includes(sensorType) && (
                        <p className="text-2xl font-bold">
                            <span className='text-md font-normal'>Niveau 1:</span> {value[0]} <span className="text-sm text-gray-500">{unit}</span>
                        </p>
                    )}
                    {supportedSensors.lvl2.includes(sensorType) && (
                        <p className="text-2xl font-bold mt-2">
                            <span className='text-md font-normal'>Niveau 2:</span> {value[1]} <span className="text-sm text-gray-500">{unit}</span>
                        </p>
                    )}
                </>
            );
        } else {
            const displayValue = Array.isArray(value) ? value[0] : value;
            return (
                <>
                    <h3 className="text-xl font-semibold mb-2 flex items-center justify-center gap-2">
                        {title}
                    </h3>
                    <p className="text-2xl font-bold">
                        {displayValue} <span className="text-sm text-gray-500">{unit}</span>
                    </p>
                </>
            );
        }
    };

    return (
        <div className={`rounded-lg shadow-md p-6 flex flex-col items-center space-y-4 text-center transition-all duration-300 hover:shadow-lg relative ${getCardStyling()}`}>
            {getAdminBadge()}
            <img src={icon} alt={title} className="w-16 h-16 mx-auto" />
            <div>
                {renderValue()}
            </div>
        </div>
    );
};

export default RenderSensorCard;